// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vBuO","newExpiryDate":"styles_newExpiryDate__3r_1K","footer":"styles_footer__24eM6"};